// Heights in this app are written as feet.inches (e.g., "5.10" = 5ft 10in, "6.2" = 6ft 2in).
// Plain numeric sorting treats "5.10" as 5.1 and orders it before "5.7", which is wrong.
// Convert to total inches before comparing.
export const heightToInches = (h) => {
  if (h === undefined || h === null) return 0;
  const [feetStr, inchStr = "0"] = String(h).split(".");
  const feet = parseInt(feetStr, 10) || 0;
  const inches = parseInt(inchStr, 10) || 0;
  return feet * 12 + inches;
};

export const sortHeights = (arr) =>
  [...(arr || [])].sort((a, b) => heightToInches(a) - heightToInches(b));

// Display form: "6.2" -> 6'2"  ·  "5.10" -> 5'10"
export const formatHeight = (h) => {
  if (!h) return "";
  const s = String(h);
  if (!s.includes(".")) return s;
  const [feet, inches] = s.split(".");
  return `${feet}'${inches}"`;
};
